var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ viewBox: "0 0 40 40" }, props),
    React.createElement("path", { className: styles["oc-icon-product"] || "oc-icon-product", d: "M34.5 23.4c0-2-.4-4.4-1.1-6.2-.8-1.8-1.8-3.7-3-5S27.5 9.7 25.7 9c-1.8-.8-3.6-1.2-5.5-1.2s-3.8.4-5.5 1.2c-1.8.8-3.3 1.8-4.5 3.1s-2.3 2.9-3 4.7c-.7 1.8-1.1 3.7-1.1 5.7 0 2.9.8 5.5 2.3 7.9.2.3.5.5.9.5l22.2-.1c.4 0 .6.1.8-.2 1.4-2.5 2.2-4.2 2.2-7.2zm-14.4 4.3c-1.2 0-2.1-.8-2.1-1.7 0-.9 1.7-11.4 2.2-11.4.5 0 2 10.5 2 11.4 0 1-1 1.7-2.1 1.7zm11.4-4.3c-.6 0-1-.7-1-1.3 0-1.4-.3-2.9-.8-4.1-.6-1.3-1.3-2.5-2.2-3.4-.9-.9-2-1.7-3.3-2.2-1.3-.5-2.6-.8-4-.8s-2.7.3-4 .8c-1.2.6-2.3 1.3-3.2 2.2-.9.9-1.6 2-2.2 3.3-.5 1.3-.8 2.8-.8 4.2 0 .6-.4 1.3-1 1.3-.5 0-1-.7-1-1.2 0-1.7.3-3.4 1-4.9.6-1.5 1.5-2.9 2.6-4s2.4-2 3.9-2.7c1.5-.7 3.1-1 4.7-1 1.7 0 3.3.3 4.8.9 1.5.6 2.8 1.5 3.9 2.6s2 2.4 2.6 3.9c.7 1.5 1 3.4 1 5 0 .7-.4 1.4-1 1.4z" })
  );
});


// WEBPACK FOOTER //
// ./icons/images/products/Dashboard.svg